import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollRestoration component that scrolls to top on route changes.
 * React Router doesn't do this by default, causing pages to open 
 * at the previous scroll position instead of the top.
 */
const ScrollRestoration = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollRestoration;
